import React, { useState, useRef, useLayoutEffect } from 'react'
import classNames from 'classnames'

import { IconButton, ICON_TYPES } from '@st-operations/uikit/src/v2/index.js'

import './useCollapsibleElement.scss'

const EXTRA_MAX_HEIGHT = 1000

// eslint-disable-next-line no-unused-vars
const useCollapsibleElement = (dependencies = [], startOpen = true, managedState) => {
  const [collapsibleHeight, setCollapsibleHeight] = useState()
  const [isOpen, setIsOpen] = managedState || useState(startOpen)
  const collapsibleRef = useRef(null)

  useLayoutEffect(() => {
    if (startOpen) {
      setCollapsibleHeight(collapsibleRef.current.scrollHeight + EXTRA_MAX_HEIGHT)
    }
  }, [...dependencies])

  const toggleCollapsible = () => setIsOpen(!isOpen)

  const TriggerCollapsible = () => {
    return (
      <IconButton
        iconProps={{
          icon: 'angledown',
          type: ICON_TYPES.OUTLINE,
          width: '24px',
          height: '24px',
        }}
        onClick={toggleCollapsible}
        ariaLabel={isOpen ? 'Hide' : 'Show'}
        classes={{
          icon: classNames('collapsible-element__icon-collapsible', {
            'collapsible-element__icon-collapsible--open': isOpen,
          }),
          button: 'collapsible-element__button-collapsible',
        }}
      />
    )
  }

  return {
    isOpen,
    collapsibleHeight: isOpen ? collapsibleHeight : 0,
    collapsibleRef,
    toggleCollapsible,
    TriggerCollapsible,
  }
}

export default useCollapsibleElement
